module.exports = __webpack_public_path__ + "img/baojiaweixinma.cc34672c.jpg";